import SectionCandidateOverview from "../sections/dashboard/section-can-overview";
import SectionCandidateAppliedJobs from "../sections/dashboard/section-can-inbox";
// import SectionCandidateProfileViews from "../sections/dashboard/section-can-profile-views";
// import SectionCandidateRecentActivities from "../sections/dashboard/section-can-activities";
import SectionCandidateJobLoops from "../sections/dashboard/section-can-applications";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { loadScript } from "../../../../globals/constants";
import { Helmet } from 'react-helmet-async';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { useTranslation } from "react-i18next";

function CanDashboardPage() {
    const { t } = useTranslation();
    const [subscriptionValid, setSubscriptionValid] = useState(null);
    const [dashboardData, setDashboardData] = useState(null);

    useEffect(() => {
        const fetchDashboardDetails = async () => {
            try {
                const res = await axiosInstance.get(`${API_URL}/Dashboards`);
                const data = res.data.data;

                setDashboardData(data);

                if (data.user?.expiry_date) {
                    const expiry = new Date(data.user.expiry_date);
                    const today = new Date();
                    setSubscriptionValid(expiry > today);
                } else {
                    setSubscriptionValid(false);
                }

            } catch (error) {
                console.error("Error fetching dashboard details:", error);
            }
        };

        fetchDashboardDetails();
    }, []);

    useEffect(() => {
        loadScript("js/custom.js")
    })

    return (
        <>
            <Helmet>
                <title>Dashboard | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>

            {/* {subscriptionValid === false && (
                <Alert variant="danger" className="alert alert-warning">
                    {t("Your public profile is currently hidden. Purchase a subscription to make your profile visible to recruiters.")}{" "}
                    <a href="/pricing">{t("Go to Pricing")}</a>
                </Alert>
            )} */}

            <div className="twm-right-section-panel site-bg-gray">

                <SectionCandidateOverview data={dashboardData} />

                <div className="twm-pro-view-chart-wrap">
                    <div className="row">
                        {/* <div className="col-xl-12 col-lg-12 col-md-12 mb-4">
                            <SectionCandidateProfileViews />
                        </div> */}
                        <div className="col-xl-12 col-lg-12 col-md-12 mb-4">
                            <SectionCandidateAppliedJobs />
                        </div>
                        {/* <div className="col-lg-12 col-md-12 mb-4">
                            <SectionCandidateRecentActivities />
                        </div> */}
                        <div className="col-lg-12 col-md-12 mb-4">
                            <SectionCandidateJobLoops />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CanDashboardPage;